import { Injectable } from "@angular/core";
import { GuiOptionsDto } from "../dto/gui-options-dto";
import { MenuItemDto } from "../dto/menu-item-dto";

@Injectable({providedIn: "root"})
export class NavigationUtils {
	constructor() { }

	constructNavigation(ermaConf: GuiOptionsDto, navItems: MenuItemDto[]): string {
		return this._addItems(ermaConf, navItems);
	}


	private _addItems(ermaConf: GuiOptionsDto, items: MenuItemDto[]): string {
		var navMenu: string = '<ul class="submenu">';

		items.forEach((item) => {
			navMenu += this._addItem(ermaConf, item);
		});

		return navMenu + '</ul>';
	}

	private _addItem(ermaConf: GuiOptionsDto, item: MenuItemDto): string {
		if (item.SubMenu != null && item.SubMenu.length > 0) {
			var subMenu = '<li class="expanded"><span (click)="clickHandler()">' + item.Description + '</span>';
			subMenu += this._addItems(ermaConf, item.SubMenu);
			subMenu += '</li>';
			return subMenu;
		}
		else {
			let url = item.Url;
			if (!url.startsWith('http') && !url.startsWith('/')) {
				url = ermaConf.baseUrl + url;
			}

			return '<li><a href="' + url + '"/>' + item.Description + '</a></li>';
		}
	};
}
